import { GlobalReducers } from './globalReducers';

export const {
  HandleChangeStateProfile,
  HandleChangeStateGlobal,
  HandleChangeModal
} = GlobalReducers.actions;